/**
 * 再生タブ（Issue #467）。動画の再生 / 一時停止・シーク・±秒・前後の発話区間・最後の応答の位置へ。
 * 開始位置と先攻は**開始位置が決まっていないときだけ**出す。「ログを1からやり直す」はデュエル一覧（ResetReplayButton）。
 */
import FirstPlayerPicker from './FirstPlayerPicker';
import { btn } from './RespondTab';
import LiveButton from './LiveButton';

export const fmtTime = (sec) => {
  const s = Math.max(0, Math.floor(sec || 0));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

export default function PlaybackTab({ time = { t: 0, d: 0, paused: true }, hasVideo = false, busy = false, hasPrev = false, hasNext = false, lastMs = null,
  needsStart = false, speechText = null, hasReplay = false, firstPlayer = 0, players = [], live = null,
  onPlayPause, onSeek, onSkip, onPrev, onNext, onSetStart, onSetFirst }) {
  const d = Number.isFinite(time.d) && time.d > 0 ? time.d : 0;
  return (
    <div data-testid="playback-tab" style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: 10, height: '100%', overflowY: 'auto', boxSizing: 'border-box', overscrollBehavior: 'contain' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontVariantNumeric: 'tabular-nums', fontSize: 13 }}>
        <span>{fmtTime(time.t)}</span>
        <input type="range" aria-label="シーク" min={0} max={d || 1} step={0.1} value={Math.min(time.t || 0, d || 1)} disabled={!hasVideo}
          onChange={(e) => onSeek?.(Number(e.target.value) * 1000)} style={{ flex: 1, minWidth: 0, height: 32 }} />
        <span style={{ opacity: 0.75 }}>{fmtTime(d)}</span>
      </div>
      {live ? <div style={{ display: 'flex' }}><LiveButton live={live} style={btn('plain', { grow: true })} /></div> : null}
      {speechText ? <div data-testid="playback-speech" style={{ fontSize: 13, opacity: 0.85, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>💬 {speechText}</div> : null}
      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" style={btn('plain', { grow: true })} disabled={!hasVideo} onClick={() => onSkip?.(-5)} aria-label="5 秒戻す">−5s</button>
        <button type="button" style={btn('plain', { grow: true })} disabled={!hasVideo} onClick={() => onSkip?.(-1)} aria-label="1 秒戻す">−1s</button>
        <button type="button" data-testid="playback-toggle" style={{ ...btn('primary', { grow: true }), fontSize: 20 }} disabled={!hasVideo} onClick={onPlayPause} aria-label={time.paused ? '再生' : '一時停止'}>{time.paused ? '▶' : '❚❚'}</button>
        <button type="button" style={btn('plain', { grow: true })} disabled={!hasVideo} onClick={() => onSkip?.(1)} aria-label="1 秒進める">+1s</button>
        <button type="button" style={btn('plain', { grow: true })} disabled={!hasVideo} onClick={() => onSkip?.(5)} aria-label="5 秒進める">+5s</button>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" style={btn('plain', { grow: true })} disabled={!hasVideo || !hasPrev} onClick={onPrev}>◀ 発話</button>
        <button type="button" style={btn('plain', { grow: true })} disabled={!hasVideo || !hasNext} onClick={onNext}>発話 ▶</button>
        <button type="button" style={btn('plain', { grow: true })} disabled={!hasVideo || lastMs == null} onClick={() => onSeek?.(lastMs)}>最後の応答へ</button>
      </div>
      {/* 開始位置と先攻は、開始位置が決まっていないときだけ（決まったあとは触らせない） */}
      {needsStart ? (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, flexWrap: 'wrap' }}>
            <span>デュエルの開始位置が決まっていません。開始の場面で押してください</span>
            <button type="button" data-testid="playback-set-start" style={btn('primary')} disabled={!hasVideo || busy || !hasReplay} onClick={onSetStart}>ここを開始位置にする</button>
          </div>
          <FirstPlayerPicker firstPlayer={firstPlayer} players={players} busy={busy} disabled={!hasReplay} onSetFirst={onSetFirst} />
        </>
      ) : null}
    </div>
  );
}
